module.exports = __webpack_public_path__ + "img/P59-zh.8389d484.png";